import { Link } from 'react-router';
import type { useAction } from '../../../api/hooks';
import { StateBadge } from '../../../ui/Badge';
import { Button } from '../../../ui/Button';
import { PageHeader } from '../../../ui/misc';
import type { ImplDetail } from './types';

const STATE_LABEL: Record<string, string> = {
  active: 'Active',
  stale: 'Stale owner',
  ready: 'Ready',
  released: 'Released',
  recovered: 'Recovered',
  terminated: 'Terminated',
};
export function ImplementationHeader({
  i,
  projectKey,
  number,
  admin,
  setDialog,
  ready,
}: {
  i: ImplDetail;
  projectKey: string | undefined;
  number: string | undefined;
  admin: boolean;
  setDialog: (dialog: 'recover' | 'evidence' | 'exception' | null) => void;
  ready: Pick<ReturnType<typeof useAction>, 'mutate' | 'isPending'>;
}) {
  const key = projectKey;
  return (
    <PageHeader
      title={`Implementation ${i.displayId}`}
      subtitle={
        <>
          <Link to={`/projects/${key}/tickets/${number}`}>{i.ticket.key}</Link> · {i.ticket.title}
        </>
      }
      actions={
        <>
          <StateBadge state={i.state} label={STATE_LABEL[i.state]} />
          {i.viewer.canRecover && (
            <Button
              variant={i.state === 'stale' ? 'primary' : 'secondary'}
              size="sm"
              onClick={() => setDialog('recover')}
            >
              Recover claim
            </Button>
          )}
          {admin && (i.state === 'active' || i.state === 'stale') && (
            <Button size="sm" variant="secondary" onClick={() => setDialog('exception')}>
              Approve exception
            </Button>
          )}
          {i.viewer.isManualOwner && (
            <>
              <Button size="sm" variant="secondary" onClick={() => setDialog('evidence')}>
                Record evidence
              </Button>
              <Button size="sm" onClick={() => ready.mutate(undefined)} loading={ready.isPending}>
                Mark pending release
              </Button>
            </>
          )}
        </>
      }
    />
  );
}
